var exports = {
  "O": "x804f0401--eaad0d--mark-block",
  "Q": "x804f0401--eaad0d--text",
};

module.exports = exports;
